<template>
  <div v-if="$ability.can('read', 'Bovine')">
    <div>
      <div
        class="p-md-12"
        style="width: 100%; padding-left: 0; padding-right: 0"
      >
        <BovineSummary :values="summary" :loading="loading" />
      </div>
      <div v-if="loading">
        <div class="p-grid" id="loading">
          <div
            class="p-col-12"
            v-for="index in bovines.length || 5"
            :key="index"
          >
            <Card>
              <template v-slot:content>
                <div class="p-grid">
                  <div class="p-col-3" v-for="index in 12" :key="index">
                    <Skeleton width="100%" height="23px" />
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
      <div v-else class="p-grid" v-for="bovine in bovines" :key="bovine.id">
        <div class="p-col-12">
          <router-link
            v-if="$ability.can('write', 'Bovine')"
            :to="{ name: 'bovine.edit', params: { id: bovine.id } }"
            style="text-decoration: none"
          >
            <BovineCard :bovine="bovine" />
          </router-link>
          <BovineCard v-else :bovine="bovine" />
        </div>
      </div>
    </div>
    <Paginator
      ref="paginator"
      :first="query.pageSize * pagination.current - 1"
      :rows="query.pageSize"
      :rowsPerPageOptions="[20, 30, 40, 50]"
      :totalRecords="pagination.total"
      @page="onPageChange"
    ></Paginator>
    <BovineCreateButton
      v-if="$ability.can('write', 'Bovine')"
    ></BovineCreateButton>
    <BovineExport :query="query"></BovineExport>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import debounce from 'debounce';
import { BovineApi } from '../../services/api';
import BovineCard from './components/BovineCard';
import BovineSummary from './components/BovineSummary';
import BovineCreateButton from './components/BovineCreateButton.vue';
import BovineExport from './components/BovineExport.vue';

export default {
  components: {
    BovineCard,
    BovineSummary,
    BovineCreateButton,
    BovineExport,
  },
  data() {
    return {
      loading: false,
      query: {
        pageSize: 20,
        page: 1,
        available: true,
        ...this.$route.query,
      },
      bovines: [],
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
      summary: {
        count: 0,
        bullCount: 0, //  Touro
        oxCount: 0, //  Boi
        cowCount: 0, //  Vaca
        calfCount: 0, //  Bezerro
        heiferCount: 0, //  Bezerra
      },
    };
  },

  async created() {
    this.loading = true;
    const paginationCache = this.getPaginationCache();
    this.query = {
      ...this.query,
      ...paginationCache,
    };
    this.$emitter.on('topbar-search', this.onTopBarSearch);
  },
  methods: {
    onTopBarSearch: debounce(function ({ query }) {
      const { page, pageSize } = this.query;
      this.query = {
        ...query,
        page,
        pageSize,
        available: !query.statusId ? true : undefined,
      };
      this.fetchBovines(query);
    }, 50),
    async fetchBovines() {
      try {
        this.loading = true;
        const [fetchResponse, fetchSummaryResponse] = await Promise.all([
          BovineApi.fetch(this.query),
          BovineApi.fetchSummary(this.query),
        ]);
        this.bovines = fetchResponse.results;
        this.pagination = fetchResponse.pagination;
        this.summary = fetchSummaryResponse;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange({ page, rows }) {
      this.query = {
        ...this.query,
        page: page + 1,
        pageSize: rows,
      };
      this.savePaginationCache();
      await this.fetchBovines();
    },
    savePaginationCache() {
      const pageQuery = {
        pageSize: this.query.pageSize,
        page: this.query.page,
      };
      localStorage.setItem('BovineListPagination', JSON.stringify(pageQuery));
    },
    getPaginationCache() {
      if (
        this.$route.params.cacheFilter &&
        localStorage.getItem('BovineListPagination')
      ) {
        return JSON.parse(localStorage.getItem('BovineListPagination'));
      } else {
        localStorage.removeItem('BovineListPagination');
      }
      return {};
    },
  },
  beforeUnmount() {
    this.$emitter.off('topbar-search');
  },
};
</script>

<style lang="css" scoped>
div >>> .p-splitbutton-defaultbutton {
  margin-right: 0 !important;
}

div >>> .p-splitbutton-menubutton {
  margin-right: 0 !important;
  width: 30px !important;
}

#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
